<h1 matDialogTitle><fa-icon icon="percent"></fa-icon> Zuschläge überschreiben</h1>

<ng-container *ngFor="let form of shownArlAllowanceFormArray; let i = index; let last = last">
    <form>
        <div class="flex gap-4 flex-wrap items-center">
<!--            <mat-form-field>-->
<!--                <mat-label>Titel</mat-label>-->
<!--                <input matInput type="text" [formControl]="form.controls.title" />-->
<!--                <mat-error *ngIf="form.controls.title.invalid"> {{ GetErrorMessage(form.controls.title) }}</mat-error>-->
<!--            </mat-form-field>-->
            <mat-form-field>
                <mat-label>Art</mat-label>
                <mat-select [formControl]="form.controls.arlType">
                    <mat-option *ngIf="form.controls.arlType.value as selected" [value]="selected">{{ARLTypeEnumNames.get(selected)}}</mat-option>
                    <mat-option *ngFor="let type of filteredTypeOptions$ | async" [value]="type.value">{{type.label}}</mat-option>
                </mat-select>
                <mat-error *ngIf="form.controls.title.invalid"> {{ GetErrorMessage(form.controls.title) }}</mat-error>
            </mat-form-field>
            <mat-form-field class="small-form-field">
                <mat-label>in %</mat-label>
                <input type="number" matInput [formControl]="form.controls.percent" />
                <span matSuffix>%</span>
                <mat-error *ngIf="form.controls.percent.invalid"> {{ GetErrorMessage(form.controls.percent) }}</mat-error>
            </mat-form-field>
            <button mat-icon-button (click)="remove(i)" matTooltip="löschen" color="warn" type="button"><fa-icon icon="trash"></fa-icon></button>
        </div>
    </form>
    <mat-divider *ngIf="!last"></mat-divider>
</ng-container>
<button mat-raised-button (click)="addRandom()" [disabled]="!(filteredTypeOptions$ | async | length)"><fa-icon icon="plus"></fa-icon>  Zuschlag hinzufügen</button>
<mat-dialog-actions class="justify-between">
        <button app-button Inverted mat-dialog-close Color="cancel">abbrechen</button>
    <button app-button (click)="save()" [Disabled]="invalid()" Color="green">überschreiben</button>
</mat-dialog-actions>
